import HealthIndicatorMeasureType from './HealthIndicatorMeasureType.jsx';

export default HealthIndicatorMeasureType;